/**
 * 用户相关 相关菜单配置
 *
 */

import { lazyLoad } from "@/utils/lazyLoad";
const vrManageRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "vr-manage",
    name: "VrManage",
    meta: {
      title: "医助管理",
      icon: "icon-operations",
      keepAlive: true,
    },
    hidden: false,
    children: [
      {
        path: "/outbound/taskpool",
        name: "TaskPool",
        component: () => import("../pages/vrManage/taskPool/index.vue"),
        meta: {
          title: "任务池",
          keepAlive: true,
        },
      },
      {
        path: "/outbound/vrTask",
        name: "VrTask",
        component: () => import("../pages/vrManage/vrTask/index.vue"),
        meta: {
          title: "外呼任务",
          keepAlive: true,
        },
      },
      {
        path: "/outbound/verbalTrick",
        name: "VerbalTrick",
        component: () => import("../pages/vrManage/verbalTrick/index.vue"),
        meta: {
          title: "话术配置",
          keepAlive: true,
        },
      },
    ],
  },
];
export default vrManageRoute;
